import React, { Component } from 'react'
import './HeaderStyles.css'


export class Header extends Component {
  render() {
    return (
      <div className='hero-img'>
          <div className='heading'>
            <h1>{this.props.heading}</h1>
            <p>{this.props.text}</p>
          </div>
      </div>
    )
  }
}